import { render, staticRenderFns } from "./ExternalPeopleAccountForm.vue?vue&type=template&id=2bf24a2c&scoped=true"
import script from "./ExternalPeopleAccountForm.vue?vue&type=script&lang=js"
export * from "./ExternalPeopleAccountForm.vue?vue&type=script&lang=js"
import style0 from "./ExternalPeopleAccountForm.vue?vue&type=style&index=0&id=2bf24a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf24a2c",
  null
  
)

export default component.exports